import ReportModelingBox from "./report-modeling-box.jsx";

export default ReportModelingBox;